var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangleDownFillIcon = function SvgTriangleDownFillIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.978 14.434a1.13 1.13 0 0 1-1.96 0L.161 2.767C-.296 1.989.253 1 1.141 1h13.715c.889 0 1.437.99.98 1.767L8.978 14.434z"
  })));
};
export default SvgTriangleDownFillIcon;